import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useReleaseVideoSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        track: yup.string().required(t("messages.inputMsgs.required")),
        type: yup.string().required(t("messages.inputMsgs.required")),
        video: yup.mixed().required(t("messages.inputMsgs.required")),
    });
};

export default useReleaseVideoSchema;
